/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SocialIconOverlay_photoQuery = {
    readonly firmName: string | null;
    readonly projectName: string | null;
    readonly projectUrl: string | null;
    readonly " $refType": "SocialIconOverlay_photoQuery";
};
export type SocialIconOverlay_photoQuery$data = SocialIconOverlay_photoQuery;
export type SocialIconOverlay_photoQuery$key = {
    readonly " $data"?: SocialIconOverlay_photoQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"SocialIconOverlay_photoQuery">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SocialIconOverlay_photoQuery",
  "type": "TradePhotosQueryOutput",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firmName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "projectName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "projectUrl",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '0792c8c919ad018e7ff591ba4490560d';
export default node;
